/**
 * Builds a new instance of the Parallax module.
 * @module Parallax
 * @constructor
 */

/** @lends module:Parallax */
function Parallax (scope, util, element, params) {
    var that = this;
    that.attribute = 'data-stry-parallax';

    /*  Catch instantiation errors  */
    if (!scope && !util && !element && !params) { return; }  //  Registration condition
    else {
        if (!scope) { console.error('StoryStream -> Parallax -> No scope provided.'); return; }
        if (!util) { console.error('StoryStream -> Parallax -> No util provided.'); return; }
        if (!element) { console.error('StoryStream -> Parallax -> No element provided.'); return; }
        if (!params) { console.error('StoryStream -> Parallax -> No params provided.'); return; }
    }
    /*  End  */

    that.elem = element;
    that.module = undefined;
    that.objects = [];
    that.uid = params.uid;
    that.velocity = (params && params.velocity) ? params.velocity : 0;

    /**
     * Funnel all events through this method and distribute.
     * @memberof Parallax
     * @function handleEvent
     * @param {object} e - Event data.
     * @inner
     */
    var handleEvent = function(e, params) {
        var type = e.type ? e.type : (e.html ? 'renderer' : false);
        switch(type) {
            case 'viewport.change':
                var len = that.objects.length;
                var data;

                //  Reset all attributes added by the Parallax component
                while (len--) {

                    //  Inline styles and matrix (these need to be recalculated after viewport change
                    that.objects[len].removeAttribute("data-parallax-matrix");
                    that.objects[len].removeAttribute("style");
                }

                //  Give the objects time to reposition
                setTimeout(function () {

                    willConstructComponent();

                }, 400);

                break;
            case 'viewport.scroll':
                len = that.objects.length;
                var obj;

                //  Only action any parallax effect if parent module is in viewport
                if (inView.is(that.module)) {

                    //  Loop through each parallax object and apply correct effect
                    while (len--) {

                        obj = that.objects[len];

                        if (obj.hasAttribute('data-parallax-depth')) {

                            whenDepthMotionRequested(obj, e);
                        }
                        else if (obj.hasAttribute('data-parallax-rotate')) {

                            whenRotateMotionRequested(obj, e);
                        }
                        else if (obj.hasAttribute('data-parallax-scale')) {

                            whenScaleMotionRequested(obj, e);
                        }
                    }
                }

                break;
        }
    };


    /**
     * Function get computed transform value from an element and parses it.
     * @memberof Parallax
     * @function willGetAndParseElementsTransformMatrix
     * @inner
     */
    var willGetAndParseElementsTransformMatrix = function (obj) {
        if(!window.getComputedStyle) return;
        var style = getComputedStyle(obj);
        var transform = style.transform || style.webkitTransform || style.mozTransform;
        var parsed = Unmatrix.parse(transform);
        return {
            'matrix' : transform,
            'parsed' : parsed
        };
    };


    /**
     * Function converts an object with the correct attributes into css string.
     * @memberof Parallax
     * @function willConvertObjectToTransform
     * @inner
     */
    var willConvertObjectToTransform = function (obj) {
        var css = "translate(" + (obj.translateX / 10) + "rem, " + (obj.translateY / 10) + "rem)";
        css += " rotate(" + obj.rotate + "deg)";
        css += " skew(" + obj.skew + "deg)";
        css += " scaleX(" + obj.scaleX + ") scaleY(" + obj.scaleY + ")";
        return css;
    };


    /**
     * Function used construct functionality for this instance.
     * @memberof Parallax
     * @function willConstructComponent
     * @inner
     */
    var willConstructComponent = function () {
        var css;
        var data;
        var len = that.objects.length;
        var obj;

        //  Loop through elements and set up parallax properties
        while (len--) {

            obj = that.objects[len];
            data = willGetAndParseElementsTransformMatrix(obj);

            //  Add start position attribute if not already done
            if (!obj.getAttribute('data-parallax-matrix')) {

                if (!data.matrix || data.matrix === 'none') {

                    obj.setAttribute('data-parallax-matrix', 'matrix(1, 0, 0, 1, 0, 0)');
                }
                else {
                    obj.setAttribute('data-parallax-matrix', data.matrix);
                }
            }

            //  Add transition delay if specified
            if (obj.getAttribute('data-parallax-delay')) {

                obj.style.transitionDelay = obj.getAttribute('data-parallax-delay') + 's';
            }
        }
    };


    /**
     * Function controls vertical motion for an element.
     * @memberof Parallax
     * @function whenDepthMotionRequested
     * @inner
     */
    var whenDepthMotionRequested = function (elem, evt) {
        var calc;
        var css;
        var depth = elem.getAttribute('data-parallax-depth');
        var matrix_base = elem.getAttribute('data-parallax-matrix');
        var relative_offset_y;
        var transform = Unmatrix.parse(matrix_base);

        //  We need to determine if the target module is in the page or at the top to calculate the offset correctly
        if (that.module.offsetTop > Math.max(document.documentElement.clientHeight, window.innerHeight || 0)) {

            //  Minus height
            relative_offset_y = evt.detail.offset_y + Math.max(document.documentElement.clientHeight, window.innerHeight || 0) - that.module.offsetTop;
        }
        else {

            //  Don't
            relative_offset_y = evt.detail.offset_y;
        }

        //  Calculate new position
        calc = transform.translateY - Math.round(relative_offset_y * (that.velocity + parseFloat(depth)));

        //  Apply to transform objectv
        transform.translateY = calc;

        //  Convert to CSS
        css = willConvertObjectToTransform(transform);

        //  Set new transforms on element
        elem.style.mozTransform = css;
        elem.style.webkitTransform = css;
        elem.style.transform = css;
    };


    /**
     * Function controls rotation for an element.
     * @memberof Parallax
     * @function whenRotateMotionRequested
     * @inner
     */
    var whenRotateMotionRequested = function (elem, evt) {
        var calc;
        var css;
        var offset = elem.getAttribute('data-parallax-rotate');
        var matrix_base = elem.getAttribute('data-parallax-matrix');
        var relative_offset_y;
        var transform = Unmatrix.parse(matrix_base);
        var direction = elem.getAttribute('data-parallax-dir');

        //  We need to determine if the target module is in the page or at the top to calculate the offset correctly
        if (that.module.offsetTop > Math.max(document.documentElement.clientHeight, window.innerHeight || 0)) {

            //  Minus height
            relative_offset_y = evt.detail.offset_y + Math.max(document.documentElement.clientHeight, window.innerHeight || 0) - that.module.offsetTop;
        }
        else {

            //  Don't
            relative_offset_y = evt.detail.offset_y;
        }

        //  Calculate new angle
        if (direction === '<') {

            calc = transform.rotate - Math.round(relative_offset_y * (that.velocity + parseFloat(offset)));
        }
        else {
            calc = transform.rotate + Math.round(relative_offset_y * (that.velocity + parseFloat(offset)));
        }

        //  Apply to transform object
        transform.rotate = calc;

        //  Convert to CSS
        css = willConvertObjectToTransform(transform);

        //  Set new transforms on element
        elem.style.mozTransform = css;
        elem.style.webkitTransform = css;
        elem.style.transform = css;
    };


    /**
     * Function controls scaling for an element.
     * @memberof Parallax
     * @function whenScaleMotionRequested
     * @inner
     */
    var whenScaleMotionRequested = function (elem, evt) {
        var calc;
        var css;
        var limit = parseFloat(elem.getAttribute('data-parallax-limit'));
        var matrix_base = elem.getAttribute('data-parallax-matrix');
        var offset = parseFloat(elem.getAttribute('data-parallax-scale'));
        var relative_offset_y;
        var scale;
        var transform = Unmatrix.parse(matrix_base);

        //  We need to determine if the target module is in the page or at the top to calculate the offset correctly
        if (that.module.offsetTop > Math.max(document.documentElement.clientHeight, window.innerHeight || 0)) {

            //  Minus height
            relative_offset_y = evt.detail.offset_y + Math.max(document.documentElement.clientHeight, window.innerHeight || 0) - that.module.offsetTop;
        }
        else {

            //  Don't
            relative_offset_y = evt.detail.offset_y;
        }

        //  Calculate scale ratio
        scale = (limit - transform.scaleX) / offset;

        //  New scale value
        calc = transform.scaleX + (scale * relative_offset_y);

        //  Only apply if scale limit set
        if (limit) {

            //  Ensure new scale value doesn't excede the scale limit
            if (calc < limit) {

                //  Set new scale value
                transform.scaleX = calc;
                transform.scaleY = calc;

                //  Convert to CSS
                css = willConvertObjectToTransform(transform);

                //  Set new transforms on element
                elem.style.mozTransform = css;
                elem.style.webkitTransform = css;
                elem.style.transform = css;
            }
        }
        else {

            console.error('STRY - Parallax : No scale limit supplied.');
        }
    };


    /**
     * Function used to initialise the application.
     * @memberof Parallax
     * @function init
     * @inner
     */
    var init = function () {

        //  Locate and store the parent module (this is used to determine whether the decoration is in view).
        that.module = STRY.util.getClosest(that.elem, function(el) {
            return STRY.util.hasClass(el, 'module');
        });

        //  Only do the following on non-touch device
        if (!scope.viewport.is_touch) {

            //  Find elements to apply effect to
            that.objects = that.elem.querySelectorAll('[data-parallax-depth], [data-parallax-rotate], [data-parallax-scale]');

            //  Setup component
            // willConstructComponent();

            //  Listeners
            scope.addEventListener('viewport.change', handleEvent);
            scope.addEventListener('viewport.scroll', handleEvent);
        }
        else {

            STRY.util.addClass(that.module, 'decor-is-static');
        }
    };

    init();
    return that;
}
if (typeof module !== 'undefined' && exports !== null) {
    exports.Parallax = Parallax;
}
